import React, { useState } from 'react'
import './SecondCommunicationBlock.css'
import secondBg from '../../asset/main-slider/second_special.avif'
import { submitOrder } from '../../api'

const SecondCommunicationBlock = () => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [isSent, setIsSent] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setIsSubmitting(true)
    try {
      await submitOrder({ name, phone, serviceName: 'Обратная связь' })
      setIsSent(true)
      setName('')
      setPhone('')
    } catch (err) {
      setError('Не удалось отправить заявку. Попробуйте ещё раз')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section
      className="second-cta"
      style={{ backgroundImage: `url(${secondBg})` }}
      aria-label="Форма обратной связи"
    >
      <div className="second-cta__overlay">
        <div className="second-cta__content">
          <h2 className="second-cta__title">
            Остались вопросы?
          </h2>
          <p className="second-cta__description">
            Заполните форму обратной связи и наш
            <br />
            менеджер свяжется с вами
          </p>

          {isSent ? (
            <p className="second-cta__description">
              Заявка отправлена, наш менеджер свяжется с вами в ближайшее время
            </p>
          ) : (
            <form className="second-cta__form" onSubmit={handleSubmit}>
              <label className="second-cta__field">
                <span className="second-cta__label">Ваше имя</span>
                <input
                  type="text"
                  name="name"
                  autoComplete="name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </label>

              <label className="second-cta__field">
                <span className="second-cta__label">Номер телефона</span>
                <input
                  type="tel"
                  name="phone"
                  autoComplete="tel"
                  required
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </label>

              {error && <p className="second-cta__error">{error}</p>}

              <button type="submit" className="second-cta__button" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : 'Получить консультацию'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}

export default SecondCommunicationBlock
